import { isNaN, isEmpty, trim } from "lodash";

export const comma = (num, fixed) => {
  if (!isNaN(Number(num))) {
    var regx = new RegExp(/(-?\d+)(\d{3})/);
    if (fixed && Number(num) % 1 > 0) {
      num = Number(Number(num).toFixed(fixed));
    }
    num = String(num);
    var bExists = num.indexOf(".", 0);
    var strArr = num.split(".");
    while (regx.test(strArr[0])) {
      strArr[0] = strArr[0].replace(regx, "$1,$2");
    }
    if (bExists > -1) {
      num = strArr[0] + "." + strArr[1];
    } else {
      num = strArr[0];
    }
  }
  return num; //문자열 반환
};

export const sliceNumber = (num, unit) => {
  if (!isNaN(Number(num)) && unit) {
    num = String(num).slice(0, unit * -1);
  }
  return num || 0;
};

// keydown event
export const enterOnlyNumber = (event) => {
  let re = new RegExp("[^0-9\\-]");
  if (event.keyCode === 8 || event.keyCode === 46) {
    return;
  } else {
    if (re.test(event.key)) {
      event.preventDefault();
      return;
    }
  }
};

export const isNumber = (num) => {
  num = trim(String(num));
  if(isEmpty(num)) {
    return false;
  }
  if (!isNaN(Number(num))) {
    return true;
  }
  return false;
};


// keydown event
export const enterOnlyNumberEnter = (event) => {
  let re = new RegExp("[^0-9\\-]");
  if (event.keyCode === 8 || event.keyCode === 13 || event.keyCode === 46) {
    return;
  } else {
    if (re.test(event.key)) {
      event.preventDefault();
      return;
    }
  }
};

export const getOnlyNumber = (num) => {
  num = trim(String(num));

  let temp = ''
  for(let i=0; i<num.length; i++) {
    if(num[i] >= '0' && num[i] <= '9') {
      temp += num[i]
    }
  }

  return temp
};
